export default "__VITE_ASSET__BHKXX2H3__"